import {useEffect} from 'react'
import Swal from 'sweetalert2'

const CURRENT_VERSION = process.env.REACT_APP_VERSION
const UPDATE_TOAST_KEY = 'updateToastDismissedAt'

let isToastVisible = false // Tracks toast visibility

const shouldShowUpdateToast = () => {
  if (isToastVisible) return false // Prevent multiple toasts

  const lastDismissTime = localStorage.getItem(UPDATE_TOAST_KEY)
  if (!lastDismissTime) return true

  const hoursPassed = (Date.now() - Number(lastDismissTime)) / (1000 * 60 * 60)
  return hoursPassed >= 24
}

const showUpdateToast = () => {
  if (!shouldShowUpdateToast()) return

  isToastVisible = true

  Swal.fire({
    toast: true,
    position: 'bottom',
    icon: 'info',
    title: '🔄 Update Available',
    text: 'A new version has been deployed. Please refresh to get the latest changes.',
    showConfirmButton: false,
    showCloseButton: true,
    allowOutsideClick: false,
    allowEscapeKey: false,
    timer: undefined,
    didClose: () => {
      isToastVisible = false // Allow showing again *after user closes*
      localStorage.setItem(UPDATE_TOAST_KEY, Date.now().toString())
    },
  })
}

export default function useVersionCheck(interval = 60000) {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        const res = await fetch(`/version.json?ts=${Date.now()}`, {cache: 'no-store'})
        if (!res.ok) throw new Error(`Failed to fetch version: ${res.status}`)
        const data = await res.json()
        if (data.version !== CURRENT_VERSION) {
          showUpdateToast()
        }
      } catch (e) {
        console.error('Error checking app version', e)
      }
    }

    const intervalId = setInterval(checkVersion, interval)
    return () => clearInterval(intervalId)
  }, [interval])
}
